import { AxiosError, AxiosResponse } from 'axios';
import moment from 'moment';
import { useMutation, UseMutationOptions } from 'react-query';
import { Session } from 'services';
import httpClient from 'utils/httpClient';

const UPDATE_CONTENT = (id: Number, courseId: Number) =>
  `/v2/course/${courseId}/session/${id}`;

export type UpdateContentBody = {
  id: Number;
  title: string;
  courseId: Number;
  vocabularyContent: string;
  studentNote: string;
  grammarContent: string;
  homeworkContent: string;
  isUnit: boolean;
  bookName: string;
  bookUnits: string;
  bookLessons: string;
  bookPages: number;
  // teacherCheckIn: string;
  // teacherCheckOut: string;
  link: string;
};

export type UpdateContentResponse = {
  session: Session;
};

export const updateContent = ({
  id,
  title,
  courseId,
  vocabularyContent,
  studentNote,
  grammarContent,
  homeworkContent,
  isUnit,
  bookName,
  bookUnits,
  bookLessons,
  bookPages,
  // teacherCheckIn,
  // teacherCheckOut,
  link,
}: UpdateContentBody) => {
  // Ensure all string fields have default values to avoid backend validation errors
  const safeTitle = title || '';
  const safeVocabulary = vocabularyContent || '';
  const safeStudentNote = studentNote || '';
  const safeGrammar = grammarContent || '';
  const safeHomework = homeworkContent || '';
  const safeBookName = bookName || '';
  const safeBookUnits = bookUnits || '';
  const safeBookLessons = bookLessons || '';
  const safeLink = link || '';

  let params = {};

  if (isUnit) {
    params = {
      title: safeTitle,
      vocabulary: safeVocabulary,
      grammar: safeGrammar,
      student_note: safeStudentNote,
      teacher_content: safeHomework,
      _content: 1,
      'is-unit': isUnit,
      book_name: safeBookName,
      book_units: safeBookUnits,
      book_lessons: safeBookLessons,
      book_pages: bookPages ? Number(bookPages) : bookPages,
      // check_in: moment(teacherCheckIn).format('HH:mm:ss'),
      // check_out: moment(teacherCheckOut).format('HH:mm:ss'),
      link: safeLink,
    };
  } else {
    params = {
      title: safeTitle,
      vocabulary: safeVocabulary,
      grammar: safeGrammar,
      student_note: safeStudentNote,
      teacher_content: safeHomework,
      _content: 1,
      book_name: safeBookName,
      book_units: safeBookUnits,
      book_lessons: safeBookLessons,
      book_pages: bookPages ? Number(bookPages) : bookPages,
      // check_in: moment(teacherCheckIn).format('HH:mm:ss'),
      // check_out: moment(teacherCheckOut).format('HH:mm:ss'),
      link: safeLink,
    };
  }
  return httpClient.put<UpdateContentResponse>(
    UPDATE_CONTENT(id, courseId),
    params,
  );
};

export const useUpdateContent = (
  opts?: UseMutationOptions<
    AxiosResponse<UpdateContentResponse>,
    AxiosError<any>,
    UpdateContentBody
  >,
) =>
  useMutation<
    AxiosResponse<UpdateContentResponse>,
    AxiosError<any>,
    UpdateContentBody
  >(updateContent, opts);
